import { PlannerVisitStatus } from "../types/visitStatus";

export const URGENCY_ORDERING: Array<PlannerVisitStatus> = [
    "impossible",
    "outOfProtocol",
    "plannableAtRisk",
    "plannableOk",
    "plannableSoon",
    "planned",
    "notYetPlannable",
];
